var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRecommend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 35 27.495"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.973a5.487 5.487 0 10-5.486-5.487 5.487 5.487 0 005.486 5.487zM29.593 13.438a4.091 4.091 0 10-4.093-4.09 4.091 4.091 0 004.093 4.09zM29.639 14.379a5.944 5.944 0 00-3.645 1.143 5.647 5.647 0 01.391 1.15l.038.176v8.911h3.858A4.719 4.719 0 0035 21.038v-3.09c-.282-1.312-1.975-3.569-5.361-3.569zM5.407 5.257A4.091 4.091 0 109.5 9.348a4.09 4.09 0 00-4.093-4.091zM0 17.948v3.09a4.719 4.719 0 004.719 4.72h3.858v-8.91l.038-.176a5.654 5.654 0 01.391-1.15 5.945 5.945 0 00-3.645-1.143c-3.386 0-5.079 2.257-5.361 3.569zM17.5 12.234c-4.54 0-6.811 3.027-7.189 4.793v7.894a2.574 2.574 0 002.574 2.574h9.23a2.574 2.574 0 002.574-2.574v-7.894c-.378-1.766-2.649-4.793-7.189-4.793z",
    fill: "#cdcdcd"
  })));
}

export default SvgIconRecommend;